class ProductCardSwatches extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('[data-href]');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const productCard = this.closest('product-card');
    if (!productCard) return;

    // Remove aria-checked from all siblings/other swatches in the block
    const allSwatches = this.querySelectorAll('.swatch-link');
    allSwatches.forEach((el) => el.removeAttribute('aria-checked'));

    // Select the current swatch
    swatch.setAttribute('aria-checked', 'true');

    // Update the product URL on the card
    productCard.productUrl = swatch.dataset.href;

    // Update the product card image if we have one
    const newImageUrl = swatch.dataset.variantImage;
    if (newImageUrl) {
      const mainImage = productCard.querySelector('.product-card-media-gallery__media img');
      if (mainImage) {
        // Simple update: We just set src and srcset to the new image URL.
        // Usually storefront returns responsive images but here we use the 1200px width from liquid.
        mainImage.src = newImageUrl;
        mainImage.srcset = newImageUrl;
      }
    }

    // Update Quick Add button variant ID if it exists natively
    const quickAddBtn = productCard.querySelector('[data-ref="add-to-cart-button"]');
    if (quickAddBtn && swatch.dataset.variantId) {
      quickAddBtn.dataset.variantId = swatch.dataset.variantId;
    }
  };
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}